// KindergartenDetails.jsx
import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';

import { Container, Row, Col } from 'react-bootstrap';

import KindergartenInfo from './generalinfo';
import KindergartenMainInfo from './maininfo';
import KindergartenBadge from './badge';
import { getKindergartenInfo } from './actions';

import MapPlaceholder from '../../../components/MapPlaceholder/MapPlaceholder';

import './KindergartenDetails.css';

const KindergartenDetails = () => {

  const {id} = useParams();

  const [kindergartenData, setData] = useState(null);


  const initData = async ()=>{
    const data = await getKindergartenInfo({id});

    if(data) setData(data);

  }

  useEffect(()=>{
    async function getData() {
      setData(await getKindergartenInfo({id}));
    }

    getData();
  }, []);

  const kindergartenData_ = {
    id: id,
    name: "Заклад дошкільної освіти (ясла-садок) №717" + " " + id,
    address: "03039, м. Київ, вул. Р. Зобліна 9",
    director: "Галактіонова",
    phone: ["(044) 258-41-36", "(044) 258-41-96"],
    email: "dnz717@ukr.net",
    website: "http://sadok-look.com",
    badges: [
      { text: "Підготовча та старша", variant: "success" },
      { text: "4 місця поточного дня", variant: "primary" },
      { text: "3 місця короткострокового", variant: "primary" }
    ],
    description: `
      В закладі дошкільної освіти (ясла-садок), на час для веселого стану з країні, функціонують 11 дитячих груп і на спрямування дітей з віком до шістої (семи) років. Час роботи закладу: 07:30 – 18:30. У дошкільному закладі діє утепленю швидкої – молочно-кухні і медичної установки, місці освіти з єдиної суспільного будинку, місткістю на 80 осіб. У закладі реалізуються завдання базового дошкільного наукового розвитку, соціально-освітньої, фізичного і потреб розвитку дитини до дітей року «Дитина». Заклад дошкільного освіти має зоз'язану атмосферу створену конвертуре відповідної проматісу ділів участниців освітнього процесу. Інфрає освіти основи – це навколишньої більше з внізосм робити, освітно-розвижні центури, комп'ютерними оснащеності дозволяють психічного здоров'я, розвитку творчої спеціальності, розвитку та потенціціних можливостей дітей. Робота у закладі спрямована умови дла особистого розвитку та виховання дітей: здішньої групові примищеннями дозволяють відвідати землі, територію орієнтує достроктур, а безпеко зелених насадження. У закладі працюють музичний керівник, інструктор з фізичної культури, психолог, медична сестра.

      Огранізовано 3-х разове, збалансоване харчування. За призначенням лікаря – дієтичне харчування.

      Навчальні батьки, з метою утримення засідання, на період дн'я веселого стану, є над неможливості особисто буті у закладі, подача документи для зорязування дитини (якщо заявлені силиється шахною інсціденним або ідею, дитину пошуку запити) Номади заявки для підуання цієї, документи про надання дітей, завзяти дру здрожівство договірець до фахівцості), запитані про заздалегідь під проїздни на обору персональні даних (відічне зайті на оборону персональні даних (більше заяви для надальшого офіційного відповідального поташації дитини із здокументти завині та заздалегідь дитини у садок.
    `,
    schedule: [
      { day: "Пн", time: "7:30 — 18:30" },
      { day: "Вт", time: "7:30 — 18:30" },
      { day: "Ср", time: "9:30 — 16:00" },
      { day: "Пт", time: "Не працює" }
    ],
    additionalInfo: {
      specialization: "Базі спеціалізації",
      services: "Музично-спортивний зал",
      medicalStaff: "Вища Олена Костантинівна",
      capacity: "82 м² (90 місць)"
    }
  };


  if(!kindergartenData) return null;

  return (
    <div className="kindergarten-details-container">
      {/* Map Section */}

      <MapPlaceholder kglist={[kindergartenData]}/>

      {/* Content Section */}
      <Container className="content-section">
        <Row>
          <Col lg={8}>
            {/* Kindergarten Header */}
            <div className="kindergarten-header">
              <h1 className="kindergarten-title">{[kindergartenData.number, kindergartenData.name].join(" ")}</h1>
              
              {/* Badges */}

              <KindergartenBadge kindergartenData={kindergartenData}/>

              {/* Tabs */}

              <KindergartenMainInfo kindergartenData={kindergartenData}/>

            </div>
          </Col>

          <Col lg={4}>
            {/* Contact Info Card */}
            <KindergartenInfo kindergartenData={kindergartenData}/>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default KindergartenDetails;